module.exports = __webpack_public_path__ + "assets/Roobert-Regular.ttf";